import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { guaranteeSteps } from '../data/salesCopy';
export function Guarantee() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-109" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl rounded-xl border-2 border-brand-sand bg-white p-4 shadow-sm sm:p-5" data-id="element-110" data-mp="222d9lehckiko">
        <div className="flex flex-col items-center gap-2 text-center" data-id="element-111" data-mp="1x5mtws9gfozs">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-sage/10 text-brand-sage" data-id="element-112" data-mp="19e7m4jywsfh5">
            <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-113" data-mp="14gpgp3k3oidw" />
          </span>
          <h2 className="font-serif text-lg font-extrabold uppercase leading-tight text-brand-sage sm:text-2xl" data-id="element-114" data-mp="1j4txg1zleju1">
            Your purchase is 100% protected
          </h2>
          <p className="text-[13px] font-bold text-brand-clay sm:text-[15px]" data-id="element-115" data-mp="qo9f876uksf3">
            Explore YIN YOGA READY™ for 14 full days.
          </p>
        </div>

        <ul className="mt-3 grid gap-x-5 gap-y-1 sm:grid-cols-2" data-id="element-116" data-mp="lowk6z5tof1f">
          {guaranteeSteps.map(step => <li key={step} className="flex items-start gap-1.5 text-[12.5px] font-medium leading-snug text-brand-charcoal/80 sm:text-[13.5px]" data-id="element-117" data-mp="oxfb4c17yttm">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-118" data-mp="ypupkzdb509r" />
              {step}
            </li>)}
        </ul>

        <div className="mt-3 space-y-1 border-t border-brand-sand/60 pt-3 text-center text-[12.5px] font-medium leading-snug text-brand-charcoal/80 sm:text-[13.5px]" data-id="element-119" data-mp="62qimounmbvc">
          <p data-id="element-120" data-mp="f0aoyc7diyct">
            If you decide the system isn't right for you, contact us within 14
            days for a full refund according to the refund terms.
          </p>
          <p className="font-bold text-brand-sage" data-id="element-121" data-mp="1qh0k90a9e5rn">
            You can explore the complete system without taking the full risk
            yourself.
          </p>
        </div>
      </div>
    </section>;
}